import { CorporateContent, ImageGrid, ImageGallery, ResponsiveImage } from '@desquared/wave-components-library';
import HighlightsSection from '@/components/Highlights/HighlightsSection';
import ProductsAisle from '../ProductsAisle/ProductsAisle';
import { fetchShape, fetchStyle } from '../Layout/useLayout';
import { sortArray } from '@/utils/index.js';
import { setImageGrid } from '@/utils/corporateUtils';
import { setGrid, setHighLights, setSlider } from '@/utils/homePageCmsCall';
import { VideoSection } from '../VideoSection/VideoSection';
import Grid from '@/components/Grid/Grid';
import SliderSection from '@/components/ContentCardSlider/SliderSection';
import Router from 'next/router';

export const setLayout = (schema, item, isMobile, defaultProductImage, imageGalleryAriaLabels) => {
  switch (schema) {
    case 'video':
      return <VideoSection {...item.content} />;
    case 'corporate_content':
      let image = undefined;
      if (item.content.image) {
        image = item.content.image.url;
      }
      const onClick = () => {
        Router.push(item.content?.redirection_link ?? '/');
      };
      return (
        <CorporateContent
          img={image}
          imgTitle={item.content.title}
          buttonText={item.content.buttontext}
          onClick={onClick}
        >
          {item.content.description && <div dangerouslySetInnerHTML={{ __html: item.content.description }}></div>}
        </CorporateContent>
      );
    case 'grid_banners':
      return (
        <Grid
          isMobile={isMobile}
          cards={setGrid(item.included.grid_cards)}
          title={item.content.title}
          columns={item.content.columns}
        ></Grid>
      );

    case 'image_grid':
      return (
        <ImageGrid
          cards={setImageGrid(item.content.image_grid_cards, isMobile)}
          isDark={!item.content?.image_grid_cards[0]?.whitebackground}
          hasRadius={false}
        />
      );
    case 'content_slider':
      let listContent = sortArray(item.content.contentcards, item.included.slidercontent);
      return (
        <SliderSection
          title={item.content.title}
          cards={setSlider(listContent, item.content.image_fill, item.content.opennewtab)}
          shape={fetchStyle(item.content.card_style)}
          style={fetchShape(item.content.card_shape)}
        ></SliderSection>
      );
    case 'highlights':
      let highlightList = sortArray(item.content.highlights, item.included.highlight);
      return (
        <HighlightsSection
          isMobile={isMobile}
          bgColor={item.lightgreybackground ? 'blue' : 'white'}
          highLightsArray={setHighLights(highlightList)}
        ></HighlightsSection>
      );
    case 'promoted_products':
      const productsSku = item.content.products_andor_offers.map(prod => {
        return prod.replace('PR', '');
      });
      return (
        <ProductsAisle
          isMobile={isMobile}
          products={productsSku}
          title={item.content.title}
          linkText={item.content.redirection_text}
          productsLink={item.content.redirection_url}
          hasPadding={false}
          limitations={item.content.limitations}
          hideLastTile={!item.content?.redirection_text || item.content?.redirection_text?.length === 0}
          defaultProductImage={defaultProductImage}
        ></ProductsAisle>
      );
    case 'image_gallery':
      let images = [];
      item.content.images.forEach(el => {
        let tempCard = {
          img: el.image,
          title: el.originalName,
        };
        images.push(tempCard);
      });
      return <ImageGallery images={images} imageGalleryAriaLabels={imageGalleryAriaLabels} />;

    case 'images':
      return <ResponsiveImage title={item.content._image.description} image={item.content._image.image} />;
  }
};
